var map = {
	"./albireo.json": 7945,
	"./ic1158.json": 1316,
	"./ic1340.json": 3324,
	"./ic1396.json": 3678,
	"./ic1590.json": 3879,
	"./ic1795.json": 1705,
	"./ic1805.json": 2050,
	"./ic2177.json": 5409,
	"./ic3355.json": 865,
	"./ic405.json": 4628,
	"./ic410.json": 1032,
	"./ic417.json": 7987,
	"./ic431.json": 8230,
	"./ic434.json": 8819,
	"./ic443.json": 6742,
	"./ic5070.json": 1708,
	"./ic5146.json": 9501,
	"./ic59.json": 1105,
	"./jner1.json": 3158,
	"./lbn576.json": 7296,
	"./lbn941.json": 3209,
	"./m1.json": 7106,
	"./m100.json": 672,
	"./m101.json": 4542,
	"./m104.json": 4836,
	"./m106.json": 7058,
	"./m109.json": 6796,
	"./m12.json": 9192,
	"./m13.json": 3845,
	"./m16.json": 2187,
	"./m17.json": 7622,
	"./m27.json": 305,
	"./m31.json": 7406,
	"./m33.json": 4035,
	"./m42.json": 9015,
	"./m45.json": 9680,
	"./m51.json": 6726,
	"./m57.json": 4449,
	"./m64.json": 6754,
	"./m8.json": 4248,
	"./m81.json": 3904,
	"./m82.json": 3565,
	"./m85.json": 6662,
	"./m92.json": 5172,
	"./m95.json": 6406,
	"./m97.json": 7808,
	"./m99.json": 3721,
	"./ngc1499.json": 6886,
	"./ngc1977.json": 4977,
	"./ngc2264.json": 2900,
	"./ngc2359.json": 7881,
	"./ngc246.json": 250,
	"./ngc281.json": 9937,
	"./ngc2903.json": 9850,
	"./ngc3172.json": 7389,
	"./ngc3718.json": 551,
	"./ngc4565.json": 2394,
	"./ngc4631.json": 8375,
	"./ngc4725.json": 8669,
	"./ngc6543.json": 6650,
	"./ngc6604.json": 2992,
	"./ngc6888.json": 555,
	"./ngc6946.json": 2583,
	"./ngc6960.json": 6253,
	"./ngc6992.json": 9657,
	"./ngc7000.json": 3110,
	"./ngc7023.json": 110,
	"./ngc7380.json": 6891,
	"./ngc7635.json": 4170,
	"./sh2-101.json": 5617,
	"./sh2-112.json": 6914,
	"./sh2-114.json": 5743,
	"./sh2-115.json": 559,
	"./sh2-119.json": 1782,
	"./sh2-129.json": 9878,
	"./sh2-132.json": 4321,
	"./sh2-157.json": 2210,
	"./sh2-170.json": 8090,
	"./sh2-173.json": 9327,
	"./sh2-199.json": 5707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3757;